import React, { Component } from 'react';
import { get, post } from 'axios';
import { isEmpty, noop } from '../../utils';
import { inject, observer } from 'mobx-react';
import Gravatar from 'react-gravatar';
import BookingsPersonalRow from './BookingsPersonalRow';
import Modal from 'react-bootstrap4-modal';
import Notifications8, {notify} from 'react-notify-toast';
import BookingQuickview from './BookingQuickview';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';


@inject('userStore')
@observer
class BookingsPersonal extends Component {
    constructor(props){
        super(props);
        this.state = {
            original_list:[],
            booking_list: [],
            business_list:[],
            quickviewVisible:false,
            searchValue:'',
            loading:false,
            activeTab:'active'
        }
    }

    componentDidMount() {
      this.fetchBookings('active');
    }


    valueChange= (event) => {
      this.setState({searchValue: event.target.value}, () => {
        // filter the array
        this.setState({
          booking_list:this.state.original_list
        }, () => {
          if (this.state.searchValue.length > 2){
            var searchList = this.state.booking_list.filter((booking) =>
              booking.email.toLowerCase().includes(this.state.searchValue.toLowerCase()) |
              booking.full_name.toLowerCase().includes(this.state.searchValue.toLowerCase()) |
              booking.location_name.toLowerCase().includes(this.state.searchValue.toLowerCase()) |
              booking.phone.toLowerCase().includes(this.state.searchValue.toLowerCase())
            );
            this.setState({
              booking_list:searchList
            });
          }
        })
      });
    }

    clearSearch = () => {
        this.setState({
            searchValue:'',
            booking_list:this.state.original_list
        })
    }

    filterBy = (filterId) => {
      this.setState({
        booking_list:this.state.original_list
      }, () => {
        if (filterId !== 0){
          let temp_booking_list = Object.assign([], this.state.booking_list).filter(booking => booking.business_id === filterId);
          this.setState({
            booking_list:temp_booking_list
          })
        }
      });
    }


    sortBy = (sortType) => {
        switch (sortType) {
            case 'LASTNAME':
                this.setState({
                    booking_list:this.state.booking_list.sort(this.sortByLastname)
                })
                break;
            case 'AGE':
                this.setState({
                    booking_list:this.state.booking_list.sort(this.sortByAge)
                })
                break;
            case 'EVENTDATE':
                this.setState({
                    booking_list:this.state.booking_list.sort(this.sortByEventdate)
                })
                break;
            default:

        }
    }

    sortByLastname = (a,b) => {
        if (a.last_name < b.last_name)
            return -1;
        if (a.last_name > b.last_name)
            return 1;
        return 0;
    }

    sortByEventdate = (a,b) => {
        if (a.days_until < b.days_until)
            return -1;
        if (a.days_until > b.days_until)
            return 1;
        return 0;
    }

    sortByAge = (a,b) => {
        if (a.age_minutes < b.age_minutes)
            return -1;
        if (a.age_minutes > b.age_minutes)
            return 1;
        return 0;
    }

    quickviewHandler = (booking) =>{
        if (this.state.quickviewVisible && this.state.quickviewBooking !== booking){
            this.setState({
                quickviewBooking:booking
            })
        } else {
            this.setState({
                quickviewVisible:!this.state.quickviewVisible,
                quickviewBooking:booking
            })
        }
    }


    selectEventByHash = (hash_id) => {
      let index = this.state.booking_list.findIndex(x => x.hash_id == hash_id);
      let booking = this.state.booking_list[index];
      this.quickviewHandler(booking);
    }


    selectEvent = (event) => {
      let index = this.state.booking_list.findIndex(x => x.id === event.id);
      let booking = this.state.booking_list[index];
      this.quickviewHandler(booking);
    }

    closeHandler = () => {
        this.setState({
            quickviewVisible:false
        })
    }

    setActiveTab = (tab) => {
      this.fetchBookings(tab);
      this.setState({
          activeTab:tab
      })
    }

    fetchBookings = (activeTab) => {
      this.setState({loading:true});
      post('v2/get/bookings', {
          filter:activeTab
        }, {
          auth: {username: this.props.userStore.token}
      }).then((res) => {
          this.setState({
              booking_list:res.data.booking_list,
              original_list:res.data.booking_list,
              events:res.data.event_list,
              business_list:res.data.business_list,
              loading:false
          }, ()=>{
              if (this.props.location.state && this.props.location.state.hash_id){
                  this.selectEventByHash(this.props.location.state.hash_id)
              }
          });
      }).catch((error) => {
        return error;
      });
    }

  render() {
      const { booking_list, original_list, booking, business_list } = this.state;
      return (
        <React.Fragment>
            <header className="header mb-0">
                <div className="header-action pt-20">
                    <ul className="nav nav-tabs">
                        <li className="nav-item cursor">
                            <a href="#" className={this.state.activeTab === "active" ? "nav-link active" : "nav-link"} onClick={() => this.setActiveTab('active')}>Active Events</a>
                        </li>
                        <li className="nav-item cursor">
                            <a href="#" className={this.state.activeTab === "past" ? "nav-link active" : "nav-link"} onClick={() => this.setActiveTab('past')}>Past Events</a>
                        </li>
                    </ul>
                </div>
            </header>
            <div className="main-content pt-0" ref={ (divElement) => this.divElement = divElement}>
            {this.state.activeTab !== 'calendar' ?
                <header className="flexbox align-items-center media-list-header bg-transparent b-0 py-16 pl-20">
                    <div className="flexbox align-items-center">
                        <div className="dropdown">
                            <a className="btn btn-sm dropdown-toggle" data-toggle="dropdown" href="#">Sort by</a>
                            <div className="dropdown-menu">
                                <a className="dropdown-item" onClick={() => this.sortBy('EVENTDATE')}>Event Date</a>
                                <a className="dropdown-item" onClick={() => this.sortBy('AGE')}>Date Created</a>
                                <a className="dropdown-item" onClick={() => this.sortBy('LASTNAME')}>Name</a>
                            </div>
                        </div>
                        <div className="dropdown">
                            <a className="btn btn-sm dropdown-toggle" data-toggle="dropdown" href="#">Filter by business</a>
                            <div className="dropdown-menu">
                              <a className="dropdown-item" onClick={() => this.filterBy(0)}>Show All</a>
                              {business_list.map((business, index)=>
                                <a key={index} className="dropdown-item" onClick={() => this.filterBy(business.id)}>{business.name}</a>
                              )}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="lookup lookup-circle lookup-right">
                            <input type="text" value={this.state.searchValue} onChange={this.valueChange}/>
                        </div>
                        {this.state.searchValue !== '' ? <button className="ml-10 btn btn-outline btn-sm btn-danger" onClick={this.clearSearch}>Clear</button> : null}
                    </div>
                </header>
            : null}
                <div className="tab-content">
                <PerfectScrollbar>
                {this.state.loading
                  ?
                  <div className="spinner-ball"></div>
                  :
                  !isEmpty(original_list) || this.state.activeTab === 'calendar' ?
                  <div id="active" className="tab-pane active media-list media-list-divided media-list-hover" data-provide="selectall">
                    {booking_list.map((booking, booking_index) =>
                      <BookingsPersonalRow booking={booking} key={booking_index} qHandler={this.quickviewHandler} handler={this.modalHandler}/>
                    )}
                  </div>
                  : <div className="p-30 fs-25 fw-500 text-center">No Results Found</div>
                }
                </PerfectScrollbar>
                </div>
            </div>
            <div className={this.state.quickviewVisible ? "quickview quickview-lg reveal" : "quickview quickview-lg"}>
            {this.state.quickviewBooking ?
                <BookingQuickview quickviewBooking={this.state.quickviewBooking} closeHandler={this.closeHandler} modalHandler={this.modalHandler} servicesHandler={this.servicesHandler} scheduleHandler={this.scheduleHandler} startTimeHandler={this.startTimeEdit}/>
              : <div>Loading</div>
            }
            </div>
        </React.Fragment>
    );
  }
}

export default BookingsPersonal;



// WEBPACK FOOTER //
// ./src/components/business/BookingsPersonal.js